export default __webpack_public_path__ + "static/media/logo-login.b3888a6e.jpg";